import store from '@/store/index.js'
let dic = store.state.dic;

import { isIdCardNo } from "@/libs/checker.js";
import { validateCardId } from "@/libs/elementChecker";

// 根据身份证号获取性别 0男 1女
function getSexByIdNO(IdNO) {
    return IdNO.charAt(IdNO.length - 2) % 2 === 0 ? 1 : 0;
}

export default function Configs(that) {

    const searchItems = [
        {
            label: "姓名",
            span: 8,
            model: "name",
            placeholder: '请输入姓名'
        },
        {
            label: "性别",
            span: 8,
            type: 'select',
            model: "sex",
            placeholder: '请选择性别',
            options: [
                {
                    value: 2,
                    label: '未知'
                },
                {
                    value: 0,
                    label: '男'
                },
                {
                    value: 1,
                    label: '女'
                }
            ],
        },
        {
            label: "身份证号",
            span: 8,
            model: "idCard",
            placeholder: '请输入身份证号'
        },
    ]
    const tableColumns = [
        
        {
            label: "学号",
            prop: "studentNo",
            prop: "studentNumber",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "姓名",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "考生号",
            prop: "studentKh",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "创建时间",
            prop: "createTime",
            align: "center",
            show: true,
            minWidth: 240,
        },
        {
            label: "图片",
            name: 'custom',
            // prop: "originImage",
            align: "center",
            show: true,
            minWidth: 100,
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]

    const formItems = [
        {
            label: "姓名",
            placeholder: '请输入姓名',
            span: 24,
            model: "name",
        },
        {
            label: "身份证号",
            span: 24,
            placeholder: '请输入身份证号',
            model: "idCard",
            disabled: false,
            change(idCardNo) {
                if (isIdCardNo(idCardNo)) {
                    that.handleData.sex = getSexByIdNO(idCardNo);
                } else {
                    that.handleData.sex = "";
                }
            }
        },
        {
            label: "性别",
            span: 24,
            placeholder: '请选择性别',
            model: "sex",
            disabled: true,
            type: 'select',
            options: [
                {
                    value: 2,
                    label: '未知'
                },
                {
                    value: 0,
                    label: '男'
                },
                {
                    value: 1,
                    label: '女'
                }
            ],
        },
        // {
        //     label: "系统标识",
        //     span: 24,
        //     placeholder: '请输入系统标识',
        //     model: "tenantId",
        //     labelWidth: '150px',
        // },
        // {
        //     label: "上传人脸信息",
        //     span: 24,
        //     placeholder: '请输入描述信息',
        //     model: "description",
        //     labelWidth: '150px',
        //     type: 'upload'
        // },

    ]
    const formRules = {
        name: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
        }],
        idCard: [{
            required: true,
            // message: "请输入身份证号",
            trigger: "blur",
            validator: validateCardId,
        }],
        url: [{
            required: true,
            message: "请上传图片",
            trigger: "blur"
        }],
    }
    return {
        formItems,
        formRules,
        tableColumns,
        searchItems
    }
}